const DIRECTION_ABBREVIATIONS: Record<string, string> = {
    north: "N",
    south: "S",
    east: "E",
    west: "W",
    northeast: "NE",
    northwest: "NW",
    southeast: "SE",
    southwest: "SW"
};

const SUFFIX_ABBREVIATIONS: Record<string, string> = {
    alley: "Aly",
    avenue: "Ave",
    beach: "Bch",
    bend: "Bnd",
    boulevard: "Blvd",
    bridge: "Brg",
    brook: "Brk",
    bypass: "Byp",
    canyon: "Cyn",
    causeway: "Cswy",
    center: "Ctr",
    circle: "Cir",
    cliff: "Clf",
    club: "Clb",
    common: "Cmn",
    corner: "Cor",
    course: "Crse",
    court: "Ct",
    cove: "Cv",
    creek: "Crk",
    crescent: "Cres",
    crest: "Crst",
    crossing: "Xing",
    dale: "Dl",
    drive: "Dr",
    estate: "Est",
    estates: "Ests",
    expressway: "Expy",
    extension: "Ext",
    falls: "Fls",
    ferry: "Fry",
    field: "Fld",
    fields: "Flds",
    forest: "Frst",
    fork: "Frk",
    fort: "Ft",
    freeway: "Fwy",
    garden: "Gdn",
    gardens: "Gdns",
    gateway: "Gtwy",
    glen: "Gln",
    green: "Grn",
    grove: "Grv",
    harbor: "Hbr",
    haven: "Hvn",
    heights: "Hts",
    highway: "Hwy",
    hill: "Hl",
    hills: "Hls",
    hollow: "Holw",
    inlet: "Inlt",
    island: "Is",
    junction: "Jct",
    knoll: "Knl",
    lake: "Lk",
    lakes: "Lks",
    landing: "Lndg",
    lane: "Ln",
    lodge: "Ldg",
    manor: "Mnr",
    meadow: "Mdw",
    meadows: "Mdws",
    mill: "Ml",
    mission: "Msn",
    mount: "Mt",
    mountain: "Mtn",
    orchard: "Orch",
    parkway: "Pkwy",
    passage: "Psge",
    place: "Pl",
    plain: "Pln",
    plaza: "Plz",
    point: "Pt",
    port: "Prt",
    prairie: "Pr",
    ranch: "Rnch",
    rapids: "Rpds",
    ridge: "Rdg",
    river: "Riv",
    road: "Rd",
    route: "Rte",
    shore: "Shr",
    skyway: "Skwy",
    spring: "Spg",
    springs: "Spgs",
    square: "Sq",
    station: "Sta",
    stream: "Strm",
    street: "St",
    summit: "Smt",
    terrace: "Ter",
    trace: "Trce",
    track: "Trak",
    trail: "Trl",
    tunnel: "Tunl",
    turnpike: "Tpke",
    valley: "Vly",
    viaduct: "Via",
    view: "Vw",
    village: "Vlg",
    vista: "Vis"
};

/**
 * HERE and Mapbox spell street types out ("North Howe Avenue") while Google's short_name abbreviates
 * them ("N Howe Ave"). Downstream street-name comparisons expect the abbreviated form.
 */
export function toStreetShortName(street?: string): string | undefined {
    if (!street) return street;

    const words = street.trim().split(/\s+/).filter(Boolean);
    if (words.length < 2) return street;

    let suffixIndex = words.length - 1;

    // A trailing direction pushes the street type one word left: "Main Street North"
    const trailingDirection = DIRECTION_ABBREVIATIONS[words[suffixIndex].toLowerCase()];
    if (trailingDirection && suffixIndex > 0) {
        words[suffixIndex] = trailingDirection;
        suffixIndex--;
    }

    // A leading direction followed only by a street type is the name itself: "North Avenue"
    const leadingDirection = DIRECTION_ABBREVIATIONS[words[0].toLowerCase()];
    const isDirectionTheName = suffixIndex === 1 && SUFFIX_ABBREVIATIONS[words[1].toLowerCase()] !== undefined;
    if (leadingDirection && !isDirectionTheName)
        words[0] = leadingDirection;

    // Guard the leading word so a lone "Park Avenue" keeps its name
    if (suffixIndex > 0)
        words[suffixIndex] = SUFFIX_ABBREVIATIONS[words[suffixIndex].toLowerCase()] ?? words[suffixIndex];

    return words.join(" ");
}
